export const isPlatformTrans = (id) => {
    const parts = id?.split(':');
    return parts?.[2] === 'platform';
};
export const schema = {
    id: 'i18n',
    name: get => `${get('lang')} ${isPlatformTrans(get('id')) ? '平台' : '用户'}译文`,
    fieldUncheckable: true,
    pickFields: ['translation'],
};
